import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cafe",
  "use": "cafe-usage",
  "viewBox": "0.945 0.947 16.491 16.234",
  "content": "<symbol viewBox=\"0.945 0.947 16.491 16.234\" id=\"cafe\"><path d=\"M16.416 1.947H1.965v-1h14.451v1zm1.02 9.081h-.859v6.153h-2.723v-6.153h-2.442v6.153H1.805v-6.153h-.86V8.477l.968-5.628h14.586l.93 5.546.007 2.633zm-1-2.551l-.782-4.628h-12.9l-.816 4.713.005 1.466h.862v6.153h7.606v-6.153h4.442v6.153h.723v-6.153h.859V8.477zM3.82 10.016h5.732v5.235H3.82v-5.235zm1 4.235h3.732v-3.235H4.82v3.235z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/cafe.svg
// module id = 148
// module chunks = 0